export default __webpack_public_path__ + "a9900615aa5ca86b459758389401700d.png";